import {
  ScreenshotGrid
} from '@roc/ui';

export {
  ScreenshotGrid
} from '@roc/ui';

export default ScreenshotGrid;